import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  ViewRef,
  HostListener,
  Input
} from '@angular/core';
import {SwitchBoard} from "../services/SwitchBoard";
import {Router} from "@angular/router";
import {StateService} from "../services/StateService";
import {LoadingService} from "../services/LoadingService";
import {CacheService} from "../services/cache.service";
import {LoginService} from "../services/Login.service";
import {ToastService} from "../services/Toast.service";
import {LogoService} from "../services/LogoService";
import {TaxPlanningService} from "../tpiq-services/tax-planning.service";
import {CommonModule} from "@angular/common";
import {Session} from "../services/Session";
import {takeUntil} from "rxjs/operators";
import {TOAST_TYPE} from "../constants/Tpiq.constants";
import {QuestionnairesSurveysService} from "../services/questionnaires-surveys.service";
import {FormsModule} from "@angular/forms";
import {FoundationInit} from "../directives/foundation.directive";
import {DoceboSsoService} from "../services/docebo-sso.service";
import {MatIconModule} from "@angular/material/icon";

declare let jQuery: any;
declare let _: any;
declare let window: any;

// The firms that show the TaxPlanIQ Academy nav icon.
// The list holds org subdomains. Remove the list when Academy goes to all firms.
const ACADEMY_ORGS = ['tpiqjason', 'onboarding', 'growthteam'];

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, FormsModule, FoundationInit, MatIconModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  selectedChannelId = '';
  @Input() isExpanded: boolean;
  user: any;
  theme = 'wallTheme';
  currentView = 'taxPlanning';
  pages = {
    wall: false,
    tools: false,
    tasks: false,
    dashboards: false,
    '1040-tracker': false,
    hop: false,
    clientData: false,
    proposalDashboards: false,
    forecast: false,
    qonnect: false,
    'reports-dashboards': false,
    revenue: false,
    proposals: false,
    leads: false,
    'proposals/tools': false,
    campaigns: false,
    'mail/inbox': false,
    'mail/sent': false,
    'mail/draft': false,
    connect: false,
    sprints: false,
    projectsTasks: false,
    bizTracker: false,
    slipping: false,
    paymes: false,
    'billing/subscriptions': false,
    invoices: false,
    clocks: false,
    taskTracker: false,
    eSignatures: false,
    arreports: false,
    timeReports: false,
    flashNews: false,
    campaignUsers: false,
    documents: false,
    qmails: false,
    taxPlanning: false,
    taxStrategies: false,
    home: false,
    tickets: false,
    qCalendar: false,
    'tax-planning/clients': false,
    meetings: false,
    secureUploads: false,
    phoneRegistry: false,
    phoneLog: false,
    expenseAccounts: false,
    proposalEngagements: false,
    'tax-planning/manage-firms': false,
    clientWorkflow: false,
    'tpiq/dashboard': false,
    organizers: false,
    firmTodos: false,
    iSolve: false,
    delayedCredits: false,
    'tax-planning/reports': false,
    'tax-planning/templates': false,
    'tax-planning/organizer': false,
    'tax-planning/events': false,
    'tax-planning/taxlab': false,
    'tax-planning/growth-plan': false,
    'tax-planning/vendors': false,
    'tpiq/onboard': false
  };
  org: string;
  orgInfo: any;
  pagesThemes = {
    wall: 'wallTheme',
    tasks: 'tasksTheme',
    dashboards: 'dashboardsTheme',
    '1040-tracker': 'indyTheme',
    clientData: 'rosterTheme',
    proposalDashboards: 'dashesTheme',
    proposals: 'proposalsTheme',
    connect: 'connectTheme',
    bizTracker: 'taxResTheme',
    slipping: 'taxResTheme',
    paymes: 'proposalsTheme',
    'billing/subscriptions': 'proposalsTheme',
    invoices: 'tasksTheme',
    taskTracker: 'taxResTheme',
    arreports: 'tasksTheme',
    qmails: 'proposalsTheme',
    taxPlanning: 'tasksTheme',
    tickets: 'proposalsTheme',
    qCalendar: 'proposalsTheme',
    organizers: 'proposalsTheme',
    firmTodos: 'proposalsTheme',
    iSolve: 'proposalsTheme'
  };
  logoSub: any;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  feedbackPageName: string;
  organizerAccess: boolean;
  currentPlan: string;
  onboardStatus: any;
  showAcademy: boolean = false;

  constructor(
    private switchBoard: SwitchBoard, private _router: Router,
    private stateService: StateService,
    private loadingService: LoadingService, private cacheService: CacheService, private loginService: LoginService,
    private toastService: ToastService, private logoService: LogoService,
    private changeDetectorRef: ChangeDetectorRef,
    private taxPlanningService: TaxPlanningService,
    private qsService: QuestionnairesSurveysService,
    private doceboSsoService: DoceboSsoService) {
  }

  ngOnInit() {
    this._init();
    this.switchBoard.onLogOut.pipe(takeUntil(this.destroy$)).subscribe(status => {
      this.cacheService.removeCache();
    });
    this.switchBoard.onToggleFeedback.pipe(takeUntil(this.destroy$))
      .subscribe(obj => {
        this.feedbackPageName = obj.pageName;
      });
    this.switchBoard.onUserOnboard.pipe(takeUntil(this.destroy$))
      .subscribe(obj => {
        let status: any = Session.get('user').onboardingStatus;
        this.onboardStatus = (status) ? status : 'Done';
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }


  _init() {
    const base = this;
    let status: any = Session.get('user').onboardingStatus;
    this.onboardStatus = (status) ? status : 'Done';
    this.org = Session.getOrg();
    this.showAcademy = this.isAcademyOrg();
    this.logoSub = this.switchBoard.onLogosReady.pipe(takeUntil(this.destroy$)).subscribe(response => {
    });
    this.user = Session.getUser();
    this.orgInfo = this.user.orgInfo || {};
    this.switchBoard.onWallTpiqSwitch.subscribe(obj => {
      if (obj.type === 'home') {
        this.changeView('home', true);
      }
      if (obj.type === 'taxPlanningHome') {
        this.changeView('tpiq/dashboard', false);
      }
      if (obj.type === 'onboardGetStarted') {
        this.changeView('tpiq/onboard', false);
      }
      this.switchBoard.onTpFirmSideBarWidthChange.next({});
    });

/*
    this.switchBoard.onTaskCompanySwitch.pipe(takeUntil(this.destroy$)).subscribe(obj => {
      this.switchBoard.onWallCompanySwitch.next(obj);
    });

    this.switchBoard.onWallSideBarChange.pipe(takeUntil(this.destroy$)).subscribe(obj => {
      this.switchBoard.onSidebarChange.next(obj);
    });

    this.switchBoard.onSidebarChange.subscribe(obj => {
      if (obj.view === 'wall-task-Tracker') {
        this.currentView = 'tasks';
        this.resetAllTabs('tasks');
        this.toggleMenu(obj.type);
      } else if (obj.view == 'taxPlanning') {
        this.changeView(obj.view, false, obj.fromTracker);
      } else {
        this.changeView(obj.view, obj.type);
      }
    });

    this.switchBoard.onTaskInfoView.subscribe(obj => {
      this.currentView = 'taskTracker';
      this.resetAllTabs('taskTracker');
    });

    this.switchBoard.onLogoClick.subscribe(data => {
      this.showPage('wall');
    });

    // revealsOpen
    this.switchBoard.onRevealOpen.pipe(takeUntil(this.destroy$)).subscribe(reveal => {
      this.openReveal(reveal);
    });

    // revealsClose
    this.switchBoard.onRevealClose.pipe(takeUntil(this.destroy$)).subscribe(reveal => {
      this.closeReveal(reveal);
    });
    this.switchBoard.onResetCurrentView.pipe(takeUntil(this.destroy$)).subscribe(flag => {
      this.isExpanded = false;
      this.currentView = 'taxPlanning';
    });

    this.switchBoard.onTaxPlanningBillingSaveOrCancel.pipe(takeUntil(this.destroy$)).subscribe(obj => {
      this.showPage('wall');
    });
*/

    this.taxPlanningService.getSubscriptionStatus(this.org, this.user.id).subscribe(response => {
      this.currentPlan = response.plan;
      if (response.accessList && response.accessList.length > 0) {
        this.organizerAccess = response.accessList.indexOf('Organizer') != -1;
      }
      if (this.organizerAccess){
        // just preload questionnaire details. Will be used when #Organizers is opened
        this.qsService.getQuestionnaireDetails(this.org, this.user.id).subscribe(questionnaire => {
        }, error => {});
      }
    });
  }

  showPage(page, fromTracker?) {
    const base = this;
    let link = [];
    const prevState = this.stateService.getPrevState();
    if (prevState && prevState.key !== 'KARLIE') {
      this.stateService.clearAllStates();
    }

    this.resetAllTabs(page);
    if (page === 'wall') {
      this.changeView('tpiq/dashboard', false);
    } else if (page === 'taxPlanning' || page === 'tpiq/dashboard') {
      if (page == 'taxPlanning' && fromTracker) {
        this.pages['tax-planning/clients'] = true;
      } else {
        this.pages['tpiq/dashboard'] = true;
      }
      link = ['tpiq/dashboard'];
      this.saveNavigatedClickAction('Dashboard');
    } else if (page === 'tax-planning/taxStrategies' || page === 'tax-planning/clients' || page === 'tax-planning/manage-firms' || page === 'tax-planning/list' || page === 'tax-planning/todos'
      || page === 'tax-planning/reports' || page === 'tax-planning/templates' || page === 'tax-planning/organizer' || page === 'tax-planning/events' || page === 'tax-planning/taxlab' || page === 'tax-planning/growth-plan'
      || page === 'tax-planning/vendors' || page === 'tpiq/onboard') {
      let action = this.getActionName(page);
      if (action) {
        this.saveNavigatedClickAction(action);
      }
      this.pages[page] = true;
      link = [page];
    }else if (page !== 'hop') {
      let action = this.getActionName(page);
      if (action) {
        this.saveNavigatedClickAction(action);
      }
      link = [page];
    }
    if (link && link.length > 0) {
      this._router.navigate(link);
    }
  }

  resetAllTabs(page) {
    const base = this;
    const user: any = Session.getUser();
    if ((user && user.isCustomer) && this.pagesThemes[page]) {
      this.changeTheme(this.pagesThemes[page]);
    }
    _.each(this.pages, function(val, key) {
      if (key === page) {
        base.pages[key] = true;
      } else {
        base.pages[key] = false;
      }
    });
    if (page === 'tasks-tools') {
      this.pages.tools = true;
    }
  }

  toggleMenu(type) {
    this.isExpanded = type;
    this.switchBoard.onSideBarExpand.next(this.isExpanded);
  }


  showError(err) {

  }

  changeTheme(type) {
    this.theme = type;
    this.switchBoard.onThemeChange.next(type);
  }

  changeView(routeName, isExpanded, fromTracker?) {
    let expandView = isExpanded;
    this.selectedChannelId = '';
    const expandedViews = ['tax-planning/home'];
    if (routeName == 'tax-planning/home') {
      this.currentView = 'taxPlanning';
      expandView = true;
    } else {
      this.currentView = routeName;
    }
    this.showPage(routeName, fromTracker);
    this.toggleMenu(expandView);
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    const base = this;
    // if (this.title.nativeElement.classList.contains('is-open')) {
    //     jQuery('#side-export-dropdown-id').foundation('toggle');
    // }
  }

  // togglePreferences($event) {
  //     $event && $event.preventDefault();
  //     $event && $event.stopImmediatePropagation();
  //     jQuery('#side-export-dropdown-id').foundation('toggle');
  //     this.user = Session.getUser();
  //     this.orgInfo = this.user.orgInfo || {};
  // }


  invokeChangeDetection() {
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

/*
  closeReveal(revealFlag) {
    this.reveal[revealFlag] = false;
  }

  openReveal(flag) {
    this.reveal[flag] = true;
    setTimeout(() => {
      this.reveal = {...this.reveal};
      this.changeDetectorRef.detectChanges();
    });
  }
*/

  handleError(error) {
    const message = error.message ? error.message : `Failed to perform action`;
    try {
      this.toastService.pop(TOAST_TYPE.error, message);
    } catch (e) {
      this.toastService.pop(TOAST_TYPE.error, message);
    }
  }

  openTaxPlanningHelpPage() {
    this.saveNavigatedClickAction('Help');
    window.open('http://meyertax-8719651.hs-sites.com/en/knowledge');
  }

  // The Academy icon shows only for the firms in ACADEMY_ORGS.
  // The check uses the host subdomain first, then the session org.
  // A white-label firm reaches the app on its own subdomain, but the org from
  // the login response is the value the rest of the sidebar gates on.
  isAcademyOrg(): boolean {
    const host = window.location.hostname || '';
    const subdomain = host.split('.')[0];
    return ACADEMY_ORGS.indexOf(subdomain) !== -1 || ACADEMY_ORGS.indexOf(this.org) !== -1;
  }

  openLearningPortal() {
    this.saveNavigatedClickAction('TaxPlanIQ Academy');
    this.doceboSsoService.redirectToDocebo();
  }

  getActionName(page) {
    let str = '';
    switch (page) {
      case 'tpiq/dashboard':
        str = 'Dashboard';
        break;
      case 'tax-planning/clients':
        str = 'Client Plans';
        break;
      case 'tax-planning/taxStrategies':
        str = 'Tax Strategies';
        break;
      case 'tax-planning/templates':
        str = 'Templates';
        break;
      case 'tax-planning/organizer':
        str = 'Questionnaire';
        break;
      case 'tax-planning/todos':
        str = 'Todos';
        break;
      case 'tasks':
        str = 'Tasks';
        break;
      case 'tax-planning/events':
        str = 'Events';
        break;
      case 'tax-planning/taxlab':
        str = 'Tax Lab';
        break;
      case 'tax-planning/growth-plan':
        str = 'Growth Plan Schedule';
        break;
      case 'tax-planning/vendors':
        str = 'Vendors';
        break;
    }
    return str;
  }

  saveNavigatedClickAction(actionName) {
    this.taxPlanningService.updateNavigatedAction(this.org, this.user.id, actionName).subscribe(response => {
    });
  }

}
